import request from 'utils/RequestManager';

import config from '../../config';

const authURL = config.AUTH_HOST;
const chatBackendURL = config.BACKEND_HOST;

export function fetchDepartments(companyId) {
    return request({
        method: 'GET',
        baseURL: chatBackendURL,
        url: `/internal-groups/${companyId}/departments`,
    }).then(response => response.data);
}

export function createDepartment(companyId, data) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/internal-groups/${companyId}/departments`,
        data
    }).then(response => response.data);
}

export function updateDepartment(departmentId, companyId, data) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/internal-groups/${companyId}/departments/${departmentId}`,
        data
    }).then(response => response.data);
}

export function createDivision(departmentId, companyId, data) {
    return request({
        method: 'POST',
        baseURL: chatBackendURL,
        url: `/internal-groups/${companyId}/departments/${departmentId}/divisions`,
        data
    }).then(response => response.data);
}

export function updateDivision(divisionId, companyId, data) {
    return request({
        method: 'PUT',
        baseURL: chatBackendURL,
        url: `/internal-groups/${companyId}/divisions/${divisionId}`,
        data
    }).then(response => response.data);
}

export function deleteGroup(groupId, companyId) {
    return request({
        method: 'DELETE',
        baseURL: chatBackendURL,
        url: `/internal-groups/${companyId}/${groupId}`,
    }).then(response => response.data);
}



// WEBPACK FOOTER //
// ./src/services/internalGroups/api.js